import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineContext } from '@hooks/discipline/discipline-context.hook'

import { defineNuxtRouteMiddleware } from '#app'

const DISCIPLINE_PATH_PREFIX = '/disciplines/'

/**
 * Every discipline tab: starts the shared read and lets the navigation go on at once; the page shows one loader
 * until the read lands. Between tabs of the same discipline nothing is reread; arriving from anywhere else rereads
 * everything, in case it changed meanwhile.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id

  if (typeof disciplineId !== 'string' || !disciplineId) return

  const isSameDiscipline = from.path.startsWith(DISCIPLINE_PATH_PREFIX) && from.params.id === disciplineId

  void useDisciplineContext().loadContext(disciplineId, isSameDiscipline ? {} : { force: true, withCustomer: true })
})
